import i18n from "../../i18n";
import React from "react";
import {
  Paper,
  Text,
  Group,
  Button,
  Checkbox,
  Stack,
} from "@mantine/core";
import { IconFile, IconDownload } from "@tabler/icons";
import moment from "moment";

const formatSize = (bytes) => {
  if (!bytes) return "--";
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};

const QuizDocumentAcknowledgment = ({
  documents = [],
  acknowledgments = [],
  onDownload,
  onAcknowledge,
}) => {
  const getAck = (docId) =>
    acknowledgments.find((a) => String(a.document) === String(docId));

  if (!documents.length) return null;

  return (
    <Stack spacing="md" mb="xl">
      <Text weight={600}>Required Documents — Please Read</Text>
      <Text size="sm" color="dimmed">
        Download and acknowledge each document before starting the quiz.
      </Text>

      {documents.map((doc) => {
        const ack = getAck(doc._id);
        return (
          <Paper key={doc._id} p="md" withBorder radius="md">
            <Group position="apart">
              <Group spacing="sm">
                <IconFile size={20} />
                <div>
                  <Text weight={500}>{doc.fileName}</Text>
                  <Text size="xs" color="dimmed">
                    {formatSize(doc.fileSize)}
                  </Text>
                </div>
              </Group>
              <Button
                size="xs"
                leftIcon={<IconDownload size={14} />}
                onClick={() => onDownload?.(doc._id)}
              >{i18n.t("Download")}</Button>
            </Group>
            <Checkbox
              mt="md"
              label={
                ack?.acknowledgedAt
                  ? `Acknowledged ${moment(ack.acknowledgedAt).format(
                      "MMM D, h:mm A"
                    )}`
                  : "I have read and understood this document"
              }
              checked={!!ack?.acknowledgedAt}
              onChange={() => onAcknowledge?.(doc._id)}
            />
          </Paper>
        );
      })}
    </Stack>
  );
};

export default QuizDocumentAcknowledgment;
